import { Title, TitleSize } from '@rhinofi/dvf-shared-ui'
import { MenuConnectedWallets } from './MenuConnectedWallets'
import { FlexContainer } from '../common/Wrappers/Containers'
import { translate } from '../../intl/i18n'

export const MenuContent = ({ close = () => {} }: { close?: () => void }) => (
  <FlexContainer $gap="16px" $direction="column" $alignItems="flex-start">
    <Title size={TitleSize.XXS}>{translate('onboarding.my_wallets')}</Title>
    <MenuConnectedWallets close={close} />
  </FlexContainer>
)
